import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-get-user-input-modal',
  templateUrl: './get-user-input-modal.component.html',
  styleUrls: ['./get-user-input-modal.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class GetUserInputModalComponent {
  @Input() title?: string;
  @Input() message?: string;
  @Input() inputValue?: string;

  constructor(private activeModal: NgbActiveModal) {}

  continue() {
    this.activeModal.close(this.inputValue);
  }

  cancel() {
    this.activeModal.dismiss();
  }
}
